import { render, staticRenderFns } from "./TinField.vue?vue&type=template&id=58d5b40e"
import script from "./TinField.vue?vue&type=script&lang=js"
export * from "./TinField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports